<template>
  <layout-base id="gtr-emails-html">
    <!-- INTRO -->
    <layout-block
      width="auto"
      style="max-width:420px; background-color: #23bd48b8; padding: 10px 12px; border-radius: 8px 8px 0 0;"
      margin="32px 0 0 0"
    >
      <!-- TITLE -->
      <layout-title :title="email.title" color="#FFFFFF" />
      <!-- Subtitle -->
      <div style="margin-top:4px; font-size: 14px; font-weight: 600; color: #FFFFFF; text-decoration: underline;">{{ email.created_at }}</div>
    </layout-block>
    <!-- BODY -->
    <layout-block
      width="auto"
      style="border-left: rgb(0 0 0 / 3%) solid 1px; border-right: rgb(0 0 0 / 3%) solid 1px; max-width:420px; padding: 32px 16px;"
      margin="0 0"
      text-align="left"
    >
      <div style="font-weight: 700;">{{ email.content.title }}</div>
      <div style="margin-top:24px; font-size: 16;">{{ email.content.body }}</div>
      <ui-button
        margin="24px 0 0 0"
        :label="email.cta.label"
        :href="email.cta.url"
        bg-color="#0c0058"
        color="#ffffff"
        borderRadius="6px"
      />
    </layout-block>
    <layout-block-separator />
    <layout-block margin="32px 0">
      <ui-logo :white="false" />
    </layout-block>
  </layout-base>
</template>

<script>
import LayoutBase from '@/components/Layout/Base.vue'
import LayoutBlock from '@/components/Layout/Block.vue'
import LayoutBlockSeparator from '@/components/Layout/Block/Separator.vue'
import LayoutTitle from '@/components/Layout/Title.vue'
import UiLogo from '@/components/UI/Logo.vue'
import UiButton from '@/components/UI/Button.vue'

export default {
  name: 'Internal',
  components: {
    LayoutBase,
    LayoutBlock,
    LayoutBlockSeparator,
    LayoutTitle,
    UiLogo,
    UiButton,
  },
  props: {
    email: {
      type: Object,
      required: true,
    },
  },
}
</script>
